var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-select',_vm._b({staticClass:"truncate",attrs:{"value":null,"options":[],"loading":_vm.loading,"disabled":_vm.disabled,"dense":"","filled":"","square":""}},'q-select',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }